<template>
    <span ref="item" v-if="data.child && data.child.length > 0"
        :class="`empty_button right_item right_item_${theme} ${!isEnable() ? 'right_item_enable_' + theme : ''}`"
        @mouseenter="handle_enter" @mouseleave="handle_leave" :style="{ height: itemSize.height + 'px' }">
        <!-- <RightMenuItemIcon :icon="data.icon" :theme="theme"></RightMenuItemIcon> -->
        <svg-icon v-if="data.icon" :iconClass="data.icon"></svg-icon>
        {{ data.name }}
        <b-icon class="right_item_arrow" local="arrow_thick_right" style="color: #3b3b3b;"></b-icon>
        <!-- <b-icon v-else class="right_item_arrow" local="arrow_thick_right" style="color: #adadad;"></b-icon> -->
        <RightMenuList v-if="data.child && data.child.length > 0" :setting="childInfo" :data="data.child" :theme="theme"
            :item-size="itemSize"></RightMenuList>
    </span>
    <span v-else :class="`empty_button right_item right_item_${theme}  ${!isEnable() ? 'right_item_enable_' + theme : ''}`"
        @click="handle_click" :style="{ height: itemSize.height + 'px' }">
        <!-- <RightMenuItemIcon :icon="data.icon" :theme="theme"></RightMenuItemIcon> -->
        <svg-icon v-if="data.icon" :iconClass="data.icon"></svg-icon>
        {{ data.name }}
    </span>
</template>
 
<script>
// import RightMenuItemIcon from "@/view/rightmenu/RightMenuItemIcon";

export default {
    name: "RightMenuItem",
    // components: {
    //     RightMenuItemIcon
    // },
    beforeCreate() {
        this.$options.components.RightMenuList = require('./rightMenuList.vue').default
    },
    props: {
        data: Object,
        theme: String,
        itemSize: Object,
        top: Number,
        left: Number,
    },
    data() {
        return {
            childPosition: "",
            childInfo: {
                status: false,
                x: 0,
                y: 0,
            },
            cancelTimer: null,
        }
    },
    methods: {
        /**
         * 鼠标进入菜单项时，计算子菜单展示的位置
         */
        handle_enter() {
            let x = 0;
            let y = 0;
            let screen = this.getScreen();
            let item = this.$refs.item;
            let itemX = this.left;//当前菜单项的x坐标
            let itemY = this.top;//当前菜单项的y坐标
            let childHeight = this.data.child.length * item.clientHeight;
            //计算坐标x
            if ((screen.width - itemX - item.clientWidth) > item.clientWidth) {
                x = itemX + item.clientWidth;
                this.childPosition = "right";
            } else if (itemX > item.clientWidth) {
                x = itemX - item.clientWidth;
            }
            if (this.childPosition === "") this.childPosition = "left";
            //计算坐标y
            if ((screen.height - itemY) > childHeight) {
                y = itemY + 10;
            } else if (screen.height > childHeight) {
                y = screen.height - childHeight - 20;
            }
            this.noCloseChild();
            this.childInfo = {
                status: true,
                x: x,
                y: y,
            }
        },
        /**
         * 鼠标离开时，判断从哪个方向离开
         * @param e
         */
        handle_leave() {
            this.noCloseChild();
            this.cancelTimer = setTimeout(() => {
                this.closeChild();
            }, 100);
        },
        /**
         * 获取窗口大小
         */
        getScreen() {
            return {
                width: document.body.clientWidth,
                height: document.body.clientHeight,
            }
        },
        isEnable() {
            return this.data.enable !== false;
        },
        /**
         * 处理点击事件，先关闭按钮，在处理点击事件
         */
        handle_click() {
            if (!this.isEnable()) return;
            this.close();
            setTimeout(() => {
                if (this.data.click) this.data.click();
            }, 10);
        },
        /**
         * 通知整个菜单关闭
         */
        close() {
            this.$parent.close();
        },
        /**
         * 关闭子菜单
         */
        closeChild() {
            this.childInfo = {
                status: false,
                x: 0,
                y: 0,
            }
            this.childPosition = "";
        },
        /**
         * 取消关闭子菜单
         */
        noCloseChild() {
            clearTimeout(this.cancelTimer);
            this.cancelTimer = null;
        },
    }
}
</script>
 
<style scoped>
.right_item {
    display: block;
    width: 100%;
    text-align: left;
    padding-left: 5px;
    font-size: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.right_item_light {
    font-size: 15px;
}

.right_item_light:hover {
    background-color: #ffffff;
}

.right_item_dark {
    color: #e2e2e2;
    font-size: 13px;
}

.right_item_dark:hover {
    background-color: #444444;
}

.right_item_enable_light {
    color: #b6b6b6;
}

.right_item_enable_dark {
    color: #797979;
}

.right_item_arrow {
    width: 25px;
    height: 25px;
    float: right;
}
</style>